import { createUserManager } from 'redux-oidc';
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { config as AppConfig} from '../config';

const authority = process.env.NODE_ENV === 'development' ? AppConfig.dev.baseIDSUrl : AppConfig.build.baseIDSUrl;

const userManagerConfig: UserManagerSettings = {
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  client_id: 'rtx200_spa',
  redirect_uri: window.location.origin + '/callback',
  response_type: 'id_token token',
  scope: 'openid profile email accountRef rtx200_api',
  authority: authority+ '/',
  silent_redirect_uri: window.location.origin + '/silent-renew',
  automaticSilentRenew: true,
  post_logout_redirect_uri: window.location.origin + '/', // IMPORTANT: the end / is required.
  accessTokenExpiringNotificationTime: 10
};

const userManager = createUserManager(userManagerConfig);

export default userManager;
